// extracted by mini-css-extract-plugin
export var arrow = "_43-6";
export var changeItem = "_43-3";
export var changesHeader = "_43-1";
export var changesList = "_43-2";
export var container = "_43-0";
export var pathLabel = "_43-4";
export var value = "_43-7";
export var valuesContainer = "_43-5";